"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const google_maps_context_provider_1 = require("../google-maps-context-provider");
require("./styles.scss");
const LocationSearchCurrentLocation = ({ setLocating, setShowError, setLocationNotFound, setLocation, className }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isLoaded } = (0, react_1.useContext)(google_maps_context_provider_1.GoogleMapsContext);
    const geocoder = (0, react_1.useRef)(null);
    if (isLoaded && geocoder.current === null) {
        geocoder.current = new google.maps.Geocoder();
    }
    const locate = () => {
        setLocating(true);
        setShowError(false);
        setLocationNotFound(false);
        return new Promise((resolve, reject) => {
            const onSuccess = (currentLocation) => {
                setLocation(currentLocation);
                setLocating(false);
                setLocationNotFound(false);
                setShowError(false);
            };
            navigator.geolocation.getCurrentPosition(async ({ coords: { latitude: lat, longitude: lng } }) => {
                if (geocoder.current === null) {
                    onSuccess({ name: "???", lat, lng });
                    console.error("Google geocoder not loaded.");
                    return resolve();
                }
                geocoder.current.geocode({
                    location: { lat, lng },
                }, (results, status) => {
                    let name = "???";
                    try {
                        if (results && results.length > 0) {
                            for (const place_type of ["sublocality", "locality"]) {
                                const place = results.find((r) => r.types.includes(place_type));
                                if (place) {
                                    name = place.formatted_address;
                                    break;
                                }
                            }
                        }
                        if (!results || results.length === 0) {
                            console.error({ status });
                        }
                    }
                    finally {
                        onSuccess({ name, lat, lng });
                    }
                });
            }, (err) => {
                console.error(err);
                setLocating(false);
                setLocationNotFound(true);
            }, {
                enableHighAccuracy: false,
                timeout: 5000,
                maximumAge: Infinity,
            });
        });
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `row ${className ? className : ""}` }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "small-12 columns" }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", className: "button button--tertiary search-currentlocation", onClick: locate }, { children: t("searchBox.searchByCurrentLocation") })) })) })));
};
exports.default = LocationSearchCurrentLocation;
